module.exports = __webpack_public_path__ + "static/media/jurisdicciones.4bdfb684.jpg";